// src/modals/InteractionModal.jsx — modale d'ajout d'une interaction sur un
// prospect (appel, email, RDV, message, relance). Pas d'édition de l'historique
// existant — c'est add-only par design.

import { useState } from "react"
import { DS } from "../lib/ui"
import { uid } from "../lib/format"
import { INTERACTION_TYPES } from "../lib/domain-constants"

import useEchapPourFermer from "../lib/useEchapPourFermer"
export default function InteractionModal({ prospectId, onSave, onClose }) {
  // Échap ferme — consigne 2026-08-14, hook partagé (pile anti-double-fermeture).
  useEchapPourFermer(onClose)

  const [type, setType] = useState(INTERACTION_TYPES[0])
  const [note, setNote] = useState("")
  const [date, setDate] = useState(new Date().toISOString().split("T")[0])
  const si = { border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,padding:"9px 12px",width:"100%",fontSize:13,outline:"none",fontFamily:DS.fontBody,background:DS.card }
  const lbl = { fontSize:11,color:DS.textMuted,marginBottom:4,fontWeight:600,textTransform:"uppercase" }
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:1002,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div className="fbz-modal-sheet" style={{background:DS.card,borderRadius:"20px 20px 0 0",padding:24,width:"100%",maxWidth:480,fontFamily:DS.fontBody}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
          <div style={{fontFamily:DS.fontDisplay,fontWeight:600,color:DS.marineDark,fontSize:17}}>Ajouter une interaction</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:DS.textMuted}}>×</button>
        </div>
        <div style={{marginBottom:12}}>
          <div style={{...lbl,marginBottom:6}}>Type</div>
          <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
            {INTERACTION_TYPES.map(t => (
              <button key={t} onClick={() => setType(t)}
                style={{padding:"6px 10px",border:`1.5px solid ${type===t?DS.corail:DS.border}`,borderRadius:DS.radiusControl,background:type===t?DS.corailSoft:DS.card,color:type===t?DS.corailText:DS.textMuted,fontWeight:type===t?700:500,fontSize:11,cursor:"pointer",fontFamily:DS.fontBody}}>
                {t}
              </button>
            ))}
          </div>
        </div>
        <div style={{marginBottom:12}}>
          <div style={lbl}>Date</div>
          <input type="date" value={date} onChange={e => setDate(e.target.value)} style={si}/>
        </div>
        <div style={{marginBottom:20}}>
          <div style={lbl}>Note</div>
          <textarea value={note} onChange={e => setNote(e.target.value)} placeholder="Résumé de l'interaction..."
            style={{...si,minHeight:80,resize:"vertical"}}/>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="fbz-press" onClick={onClose} style={{flex:1,padding:12,background:DS.card,color:DS.marine,border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,fontWeight:600,cursor:"pointer",fontFamily:DS.fontBody}}>Annuler</button>
          <button className="fbz-press" onClick={() => onSave({ id: uid(), type, note, date })}
            style={{flex:2,padding:12,background:DS.corail,color:"#fff",border:"none",borderRadius:DS.radiusControl,fontWeight:700,cursor:"pointer",fontFamily:DS.fontBody}}>
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  )
}
